// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"580":"cc991913","732":"6bc58f06"}[chunkId] + ".chunk.css";
};